import { render } from "./referee-sidebar.vue?vue&type=template&id=b712c4e8&scoped=true"
import script from "./referee-sidebar.vue?vue&type=script&lang=js"
export * from "./referee-sidebar.vue?vue&type=script&lang=js"

import "./referee-sidebar.vue?vue&type=style&index=0&id=b712c4e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b712c4e8"]])

export default __exports__